import React from "react";
import { AudioOutlined, DownOutlined, SmileOutlined } from "@ant-design/icons";
import { Input, Space, Dropdown } from "antd";
import { IoSearch } from "react-icons/io5";
import { LuSettings2 } from "react-icons/lu";

const items = [
  {
    key: "1",
    label: (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.antgroup.com"
      >
        1st menu item
      </a>
    ),
  },

  {
    key: "4",
    danger: true,
    label: "a danger item",
  },
];

const { Search } = Input;
const suffix = (
  <Dropdown
    trigger={["click"]}
    menu={{
      items,
    }}
    placement="bottomRight"
  >
    <a onClick={(e) => e.preventDefault()}>
      <Space>
        <LuSettings2 size={20} />
      </Space>
    </a>
  </Dropdown>
);
const onSearch = (value, _e, info) => console.log(info?.source, value);
const SearchBar = () => (
  <Search
    placeholder="search"
    enterButton={<IoSearch />}
    size="large"
    suffix={suffix}
    onSearch={onSearch}
    className="search_bar"
  />
);
export default SearchBar;
